import styled from "styled-components";

const NoPaddedRow = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export default NoPaddedRow;
